import React from 'react';
import { useNavigate } from 'react-router-dom';
import apiHooks from '../../../hooks/apiHooks';
import dayjs from 'dayjs';
import ListDataPage from '../../../components/pages/ListDataPage';
import RevealDropdown, {
  RevealDropdownTrigger
} from 'components/base/RevealDropdown';
import ActionDropdownItems from 'components/common/ActionDropdownItems';
import { convertCrmOpportunityToCustomer } from '../../../services/crmOpportunityService';

interface ActionItem {
  eventKey: string;
  label: string;
  type: 'function' | 'redirect'; // Ensure type is restricted
  callback?: () => void;
  url?: string;
  className?: string;
  divider?: boolean;
}

const CampaignList = () => {
  const navigate = useNavigate(); // React Router hook for navigation

  // Function to return properly typed actions for each row
  const getActions = (
    opportunity_id: string,
    institutes_id: string = ''
  ): ActionItem[] => [
    {
      eventKey: '1',
      label: 'View',
      type: 'function',
      callback: () =>
        navigate(`/crm/opportunities/opportunity-details/${opportunity_id}`)
    },
    {
      eventKey: '2',
      label: 'Edit',
      type: 'function',
      callback: () =>
        navigate(`/crm/opportunities/edit-opportunity/${opportunity_id}`)
    }
  ];

  const columns = [
    { accessorKey: 'campaign_id', header: 'Campaign ID' },
    { accessorKey: 'name', header: 'Name' },
    { accessorKey: 'start_date', header: 'Start date' },
    { accessorKey: 'end_date', header: 'End date' },
    { accessorKey: 'utm_source', header: 'UTM Source' },
    { accessorKey: 'utm_medium', header: 'UTM Medium' },
    { accessorKey: 'utm_campaign', header: 'UTM Campaign' },
    { accessorKey: 'status', header: 'Status' },
    {
      accessorKey: 'created_at',
      header: 'Created At',
      cell: ({ row }: { row: any }) => (
        <span>
          {dayjs(row.original.created_at).format('DD/MM/YYYY HH:mm:ss')}
        </span>
      )
    },
    {
      id: 'action',
      header: 'Actions',
      cell: ({ row }: { row: any }) => (
        <RevealDropdownTrigger style={{ zIndex: '999' }}>
          <RevealDropdown>
            <ActionDropdownItems
              actions={getActions(
                row.original.campaign_id,
                row.original.campaign_id
              )}
            />
          </RevealDropdown>
        </RevealDropdownTrigger>
      ),
      meta: {
        headerProps: { style: { width: '7%' } },
        cellProps: { className: 'text-center' }
      }
    }
  ];

  return (
    <ListDataPage
      apiHook={apiHooks.useCampaigns}
      entityName="Campaign"
      columns={columns}
    />
  );
};

export default CampaignList;
